module.exports = __webpack_public_path__ + "static/media/46.579a20a9.jpg";